export const invoicesBackups = {
	title: "Backups",
	description: "invoices files issued per month.",
	filters: {
		fiscalProfile: {
			label: "Fiscal profile",
			placeholder: "Search by fiscal profile",
		},
	},
	table: {
		fiscalProfile: "Fiscal profile",
		month: "Month",
		files: "Files",
		downloadDanfes: "Download DANFEs",
		downloadXmls: "Download XMLs",
		unavaliable: "unavailable",
	},
};
